"use strict";

require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.weak-map.js");
exports.__esModule = true;
exports.DocumentViewer = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.values.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.string.starts-with.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.url.js");
require("core-js/modules/web.url.to-json.js");
require("core-js/modules/web.url-search-params.js");
var _fileSaver = _interopRequireDefault(require("file-saver"));
var PDFObject = _interopRequireWildcard(require("pdfobject"));
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var EApplicationPdfMimetype;
(function (EApplicationPdfMimetype) {
  EApplicationPdfMimetype["APPLICATION_PDF"] = "application/pdf";
})(EApplicationPdfMimetype || (EApplicationPdfMimetype = {}));
var EApplicationMsoMimetype;
(function (EApplicationMsoMimetype) {
  EApplicationMsoMimetype["APPLICATION_ACCESS"] = "application/msaccess";
  EApplicationMsoMimetype["APPLICATION_PPT"] = "application/mspowerpoint";
  EApplicationMsoMimetype["APPLICATION_PPTM"] = "application/vnd.ms-powerpoint";
  EApplicationMsoMimetype["APPLICATION_PPTX"] = "application/vnd.openxmlformats-officedocument.presentationml";
  EApplicationMsoMimetype["APPLICATION_XLS"] = "application/msexcel";
  EApplicationMsoMimetype["APPLICATION_XLSM"] = "application/vnd.ms-excel";
  EApplicationMsoMimetype["APPLICATION_XSLX"] = "application/vnd.openxmlformats-officedocument.spreadsheetml";
  EApplicationMsoMimetype["APPLICATION_DOC"] = "application/msword";
  EApplicationMsoMimetype["APPLICATION_DOCM"] = "application/vnd.ms-word";
  EApplicationMsoMimetype["APPLICATION_DOCX"] = "application/vnd.openxmlformats-officedocument.wordprocessingml";
})(EApplicationMsoMimetype || (EApplicationMsoMimetype = {}));
var EApplicationMimetype;
(function (EApplicationMimetype) {
  EApplicationMimetype["APPLICATION_XML_MIMETYPE"] = "application/xml";
  EApplicationMimetype["APPLICATION_XHTML_MIMETYPE"] = "application/xhtml+xml";
  EApplicationMimetype["APPLICATION_JSON_MIMETYPE"] = "application/json";
  EApplicationMimetype["APPLICATION_JSON_REPORT_MIMETYPE"] = "application/json-report";
  EApplicationMimetype["APPLICATION_LDJSON_MIMETYPE"] = "application/ld+json";
  EApplicationMimetype["APPLICATION_FEEDJSON_MIMETYPE"] = "application/feed+json";
})(EApplicationMimetype || (EApplicationMimetype = {}));
var ETextMimetype;
(function (ETextMimetype) {
  ETextMimetype["TEXT_MIMETYPE"] = "text/";
  ETextMimetype["TEXT_CALENDAR_MIMETYPE"] = "text/calendar";
  ETextMimetype["TEXT_CSV_MIMETYPE"] = "text/csv";
})(ETextMimetype || (ETextMimetype = {}));
var EImageMimetype;
(function (EImageMimetype) {
  EImageMimetype["IMAGE_MIMETYPE"] = "image/";
})(EImageMimetype || (EImageMimetype = {}));
var EAudioMimetype;
(function (EAudioMimetype) {
  EAudioMimetype["AUDIO_FLAC"] = "audio/flac";
  EAudioMimetype["AUDIO_X_FLAC"] = "audio/x-flac";
  EAudioMimetype["AUDIO_MPEG_4"] = "audio/mp4";
  EAudioMimetype["AUDIO_OGG"] = "audio/ogg";
  EAudioMimetype["AUDIO_WEBM"] = "audio/webm";
  EAudioMimetype["AUDIO_AAC"] = "audio/acc";
  EAudioMimetype["AUDIO_MPEG"] = "audio/mpeg";
})(EAudioMimetype || (EAudioMimetype = {}));
var EVideoMimetype;
(function (EVideoMimetype) {
  EVideoMimetype["VIDEO_MPEG_4"] = "video/mp4";
  EVideoMimetype["VIDEO_OGG"] = "video/ogg";
  EVideoMimetype["VIDEO_WEBM"] = "video/webm";
})(EVideoMimetype || (EVideoMimetype = {}));
var canPdfDisplayed = function canPdfDisplayed(contentType) {
  return compareMimetypes(contentType, EApplicationPdfMimetype.APPLICATION_PDF) && PDFObject.supportsPDFs;
};
var compareMimetypes = function compareMimetypes(contentType) {
  var lowerContentType = contentType.split(';')[0].toLowerCase();
  var comparison = false;
  for (var _len = arguments.length, mimetypes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    mimetypes[_key - 1] = arguments[_key];
  }
  if (mimetypes) {
    mimetypes.forEach(function (mimetype) {
      comparison = comparison || (lowerContentType === null || lowerContentType === void 0 ? void 0 : lowerContentType.startsWith(mimetype));
    });
  }
  return comparison;
};
var canApplicationDisplayed = function canApplicationDisplayed(contentType) {
  return compareMimetypes.apply(void 0, [contentType].concat(Object.values(EApplicationMimetype)));
};
var canTextDisplayed = function canTextDisplayed(contentType) {
  return contentType.startsWith(ETextMimetype.TEXT_MIMETYPE) && !compareMimetypes(contentType, ETextMimetype.TEXT_CALENDAR_MIMETYPE);
};
var canImageDisplayed = function canImageDisplayed(contentType) {
  return contentType.startsWith(EImageMimetype.IMAGE_MIMETYPE);
};
var canVideoDisplayed = function canVideoDisplayed(contentType) {
  return compareMimetypes.apply(void 0, [contentType].concat(Object.values(EVideoMimetype)));
};
var canAudioDisplayed = function canAudioDisplayed(contentType) {
  return compareMimetypes.apply(void 0, [contentType].concat(Object.values(EAudioMimetype)));
};
var canBeDisplayed = function canBeDisplayed(contentType) {
  return canPdfDisplayed(contentType) || canApplicationDisplayed(contentType) || canTextDisplayed(contentType) || canImageDisplayed(contentType) || canVideoDisplayed(contentType) || canAudioDisplayed(contentType);
};
var downloadDocument = function downloadDocument(content, contentName) {
  _fileSaver["default"].saveAs(content, contentName);
};
var DownloadDocument = function DownloadDocument(_ref) {
  var embedded = _ref.embedded,
    documentName = _ref.documentName,
    hideDownloadButton = _ref.hideDownloadButton,
    labels = _ref.labels,
    blob = _ref.blob,
    file = _ref.file;
  var _useState = (0, _react.useState)(!embedded),
    autoDownload = _useState[0],
    setAutoDownload = _useState[1];
  if (embedded) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
      children: hideDownloadButton === 'false' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactstrap.Button, {
        color: 'primary',
        onClick: function onClick() {
          return downloadDocument(blob, documentName);
        },
        children: labels.downloadButton
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: 'w-100 text-center text-secondary mt-5 pt-5',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
          className: 'icon icon-xl',
          children: "visibility_off"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
          children: labels.downloadInfo
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: 'pb-5 mb-5',
          children: labels.downloadInfoDetails
        })]
      })
    });
  } else if (!embedded) {
    if (autoDownload) {
      _fileSaver["default"].saveAs(file, documentName);
      setAutoDownload(false);
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
      className: 'permalink-container',
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: 'container text-center py-5 permalink-container__fallback',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
          className: 'display-4 mb-5',
          children: labels.downloadTitle
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
          children: [labels.downloadInfo, /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), labels.downloadActionPart1, /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
            href: file,
            download: documentName,
            children: labels.downloadActionPart2
          })]
        })]
      })
    });
  } else {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
};
var DocumentViewer = exports.DocumentViewer = function DocumentViewer(_ref2) {
  var blob = _ref2.blob,
    contentType = _ref2.contentType,
    contentName = _ref2.contentName,
    hideDownloadButton = _ref2.hideDownloadButton,
    labels = _ref2.labels,
    additionalClassNames = _ref2.additionalClassNames,
    _ref2$embedded = _ref2.embedded,
    embedded = _ref2$embedded === void 0 ? true : _ref2$embedded;
  if (contentType) {
    var canDocumentBeDisplayed = canBeDisplayed(contentType);
    var file;
    if (compareMimetypes(contentType, ETextMimetype.TEXT_CSV_MIMETYPE)) {
      file = window.URL.createObjectURL(new Blob([blob], {
        type: 'text/plain'
      }));
    } else if (compareMimetypes(contentType, EApplicationMimetype.APPLICATION_JSON_REPORT_MIMETYPE)) {
      file = window.URL.createObjectURL(new Blob([blob], {
        type: EApplicationMimetype.APPLICATION_JSON_MIMETYPE
      }));
    } else {
      file = window.URL.createObjectURL(blob);
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
      style: {
        height: !embedded ? 'calc(100vh - 7.5rem)' : canDocumentBeDisplayed ? '728px' : '100%',
        width: '100%',
        marginTop: !embedded ? '-0.8rem' : '0'
      },
      children: canDocumentBeDisplayed ? /*#__PURE__*/(0, _jsxRuntime.jsx)("iframe", {
        width: '100%',
        height: '100%',
        title: 'Document view',
        src: compareMimetypes(contentType, EApplicationPdfMimetype.APPLICATION_PDF) ? file + "#view=Fit" : file,
        className: additionalClassNames
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(DownloadDocument, {
        embedded: embedded,
        blob: blob,
        documentName: contentName,
        file: file,
        hideDownloadButton: hideDownloadButton,
        labels: labels
      })
    });
  } else {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
};